var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectedSubCategories",class:[{ 'selectedSubCategories--disableWhiteBackground': _vm.data.disableWhiteBackground }]},[_c('div',{staticClass:"container"},[_c('SectionContainer',{attrs:{"title":_vm.data.title,"small-title":_vm.data.smallTitle,"disable-white-background":_vm.data.disableWhiteBackground,"link":_vm.categoryObject
          ? {
              smallTitle: _vm.data.smallTitle ? _vm.data.smallTitle : '',
              title: 'ZOBACZ WSZYSTKIE',
              path: _vm.localePath({ name: 'category-slug', params: { slug: _vm.categoryObject.slug } }),
            }
          : undefined}},[_c('div',{staticClass:"selectedSubCategories__content"},[_c('CategoriesWithListGrid',{attrs:{"items":_vm.categories}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }